
import React, { useRef, useState } from 'react';
import {
    Grid,
    Typography,
    Button,
    Autocomplete,
    Box,
} from '@mui/material';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import InputAdornment from '@mui/material/InputAdornment';
import TextField from '@mui/material/TextField';
import CustomDepartmentSelect from '../../../pages/Member-Profile-Edit/CustomDepartmentSelect';

import AttachFileIcon from '@mui/icons-material/AttachFile';

import MyDatePicker from '../../../components/Date-range-picker/MyDatePicker';

const labelStyle = {
    marginBottom: '4px',
    fontWeight: 600,
    color: '#1A1A1A',
    fontSize: '14px',
    fontFamily: 'Manrope'
};

const inputStyle = {
    height: '46px',
    backgroundColor: '#fff',
    fontSize: '13px',
    fontFamily: 'Manrope'
};

const Organization = ({ onCancel, onSave }) => {
    const industryOptions = [
        'Manufacturing', 'Marketing & advertising', 'Media', 'Non-profit', 'Professional services', 'Property management', 'Public relation & communications', 'Real estate',
    ]

    const currencyOptions = [
        'USD - United States Dollar', 'EUR - Euro', 'GBP - British Pound', 'AUD - Australian Dollar', 'CAD - Canadian Dollar', 'JPY - Japanese Yen', 'CNY - Chinese Yuan Renminbi',
    ]
    const startWeekOptions = [
        'Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday',
    ]
    const timeZoneOptions = [
        '(GMT-12:00) Etc/GMT+12', '(GMT-11:00) Pacific/Pago_Pago', '(GMT-09:00) America/Adak', '(GMT-10:00) Pacific/Honolulu', '(GMT-09:30) Pacific/Marquesas', '(GMT-08:00) America/Los_Angeles', '(GMT-07:00) America/Denver',
    ]







    const fileInputRef = useRef(null);
    const [fileName, setFileName] = useState('');

    const handleButtonClick = () => {
        fileInputRef.current.click();
    };

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setFileName(file.name);
            // Optional: handle preview/upload
        }
    };



    return (
        <form>

            <Grid container spacing={2}>
                <Grid item size={{ xs: 12, md: 6 }}>
                    <Typography variant="body2" sx={labelStyle}>
                        Name <span style={{ color: 'black' }}>*</span>
                    </Typography>
                    <TextField
                        fullWidth
                        placeholder="Enter Organization Name"
                        variant="outlined"
                        InputProps={{ sx: inputStyle }}
                    />
                </Grid>
                {/* Job Type */}
                <Grid item size={{ xs: 12, md: 6 }}>
                    <Typography variant="body2" sx={labelStyle}>
                        Industry <span style={{ color: 'black' }}>*</span>
                    </Typography>
                    <CustomDepartmentSelect selectedPlaceholder="Select  your insdustry" modalSearchplaceHolder="Search insdustry" initialOptions={industryOptions} showAddOption={false} />
                    <Typography sx={{ fontSize: '10px', fontWeight: '400', color: '#64748B', fontFamily: 'Manrope', margin: '2px auto' }}>Choose a more prevalent industry to access improved averages and comparisons.</Typography>
                </Grid>

                <Grid item size={{ xs: 12, md: 6 }}>
                    <Typography variant="body2" sx={labelStyle}>
                        Address
                    </Typography>
                    <TextField
                        fullWidth
                        placeholder="Enter your organization address"
                        variant="outlined"
                        InputProps={{ sx: inputStyle }}
                    />
                </Grid>


                {/* Department */}
                <Grid item size={{ xs: 12, md: 4 }}>
                    <Typography variant="body2" sx={labelStyle}>
                        Logo
                    </Typography>
                    <Box display="flex" alignItems="center" sx={{ gap: 2 }}>
                        <input
                            type="file"
                            accept="image/*"
                            style={{ display: 'none' }}
                            ref={fileInputRef}
                            onChange={handleFileChange}
                        />
                        <Button onClick={handleButtonClick} variant="outlined" startIcon={<AttachFileIcon />}
                            sx={{ minWidth: '40%', borderRadius: '8px', borderColor: '#CC33FF', color: '#CC33FF', backgroundColor: '#CC33FF33', fontWeight: '600', fontSize: '14px', fontFamily: 'Manrope',
                                padding: '8px 16px', textTransform: 'none', '&:hover': { backgroundColor: '#F0CCF5', borderColor: '#DA33FF', },
                            }}>
                            Upload Logo
                        </Button>
                        {fileName && (
                            <Typography
                                sx={{
                                    marginTop: '0',
                                    fontSize: '14px',
                                    color: '#333',
                                    fontFamily: 'Manrope',
                                }}
                            >
                                Selected file: <strong>{fileName}</strong>
                            </Typography>
                        )}
                    </Box>
                </Grid>
                <Grid item size={{ xs: 12, md: 6 }}>
                    <Typography variant="body2" sx={labelStyle}>
                        Tax ID
                    </Typography>
                    <TextField
                        fullWidth
                        placeholder="Enter Tax ID"
                        variant="outlined"
                        InputProps={{ sx: inputStyle }}
                    />
                </Grid>


                <Grid item size={{ xs: 12, md: 6 }}>
                    <Typography variant="body2" sx={labelStyle}>
                        Currency <span style={{ color: 'black' }}>*</span>
                    </Typography>
                    <CustomDepartmentSelect selectedPlaceholder="Select  your Currency" modalSearchplaceHolder="Search Currency" initialOptions={currencyOptions} showAddOption={false} />

                </Grid>


                <Grid item size={{ xs: 12, md: 6 }}>
                    <Typography variant="body2" sx={labelStyle}>
                        Start week on <span style={{ color: 'black' }}>*</span>
                    </Typography>
                    <CustomDepartmentSelect selectedPlaceholder="Select your start week on" modalSearchplaceHolder="Search" initialOptions={startWeekOptions} showAddOption={false} />
                </Grid>




                <Grid item size={{ xs: 12, md: 6 }}>
                    <Typography variant="body2" sx={labelStyle}>
                        Time zone <span style={{ color: 'black' }}>*</span>
                    </Typography>
                    <CustomDepartmentSelect selectedPlaceholder="Select time zone" modalSearchplaceHolder="Search Time zone" initialOptions={timeZoneOptions} showAddOption={false} />
                    <Typography sx={{ fontSize: '10px', fontWeight: '400', color: '#64748B', fontFamily: 'Manrope', margin: '2px auto' }}>Please read the support article about the effects of changing time zones.</Typography>
                </Grid>


                {/* Action Buttons */}
                <Grid item size={{ xs: 12, md: 12 }} sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2, mt: 2 }}>
                    <Button
                        variant="outlined"
                        color="inherit"
                        sx={{
                            fontSize: '14px',
                            borderRadius: '50px',
                            background: '#fff',
                            border: '1px solid #9095A1',
                            color: '#9095A1',
                        }}
                        onClick={onCancel}
                    >
                        Cancel
                    </Button>
                    <Button
                        variant="contained"
                        color="primary"
                        sx={{
                            fontSize: '14px',
                            borderRadius: '50px',
                            background: '#0076FE',
                            border: '1px solid #0076FE',
                            color: '#fff',
                        }}
                        onClick={onSave}
                    >
                        Save
                    </Button>
                </Grid>
            </Grid>
        </form>
    );
};

export default Organization;
